import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchPickupAddressList = createAsyncThunk(
  "address/fetchPickupAddressList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/orders/pickup-points`);
      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch pickup-points");
    }
  }
);

export const fetchHomeAddressList = createAsyncThunk(
  "address/fetchHomeAddressList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/orders/home-addresses`);
      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch home-addresses");
    }
  }
);

export const fetcCharityAddressList = createAsyncThunk(
  "address/fetcCharityAddressList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/orders/charity-organizations`);
      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch charity-organizations");
    }
  }
);

export const addHomeAddress = createAsyncThunk(
  "address/addHomeAddress",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `checkout/add-home-delivery-address`,
        payload
      );
      return data;
    } catch (error) {
      return rejectWithValue("Failed to add home address");
    }
  }
);

export const getAvailableCities = createAsyncThunk(
    'user/getAvailableCities',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/user/get-available-cities`, payload);
            return data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to fetch available cities'
            );
        }
    }
);

export const getAvailableStates = createAsyncThunk(
    'user/getAvailableStates',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`/core/states`, payload);
            return data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || 'Failed to fetch available cities'
            );
        }
    }
);